import React from 'react'
import mypdf from '../../pdf/AsWIN2024.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={mypdf} download className='btn'>Download CV</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA